import React, { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import moment from "moment";
import $ from "jquery";

const UpdateStaffSalary = ({
  selectedRowsData,
  updateHandleChange,
  getData,
  setselectedRowsData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const formRef = useRef(null);
  const companyName = selectedRowsData.company?.company_name || "";
  const companyLocation = selectedRowsData.company?.location || "";
  const [staff, setStaff] = useState([]);
  const [personName, setPersonName] = useState("");
  const [company, setCompany] = useState([]);
  const [companyId, setCompanyId] = useState("");
  function resetFileds() {
    setselectedRowsData({
      company_id: "",
      date: "",
      staff_name: "",
      attendance: "",
      basic: "",
      da: "",
      salary: "",
      net_salary: "",
      advance: "",
      amount: "",
    });
    setCompanyId("");
    setPersonName("");
  }

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };
  const updateData = async (e) => {
    e.preventDefault();
    const {
      id,
      company_id,
      date,
      staff_id,
      attendance,
      basic,
      da,
      salary,
      net_salary,
      advance,
      amount,
    } = selectedRowsData;
    let BASE_URL = SERVER_URL + `/api/staff-salary/staff-salary/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id: companyId,
        date,
        staff_id: personName,
        attendance,
        basic,
        da,
        salary,
        net_salary,
        advance,
        amount,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      resetFileds();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setCompanyId(value ? value : "");
    setStaff([]);
    setPersonName("");
  };

  const handleOfficeUtils = (e) => {
    const selectedStaffId = e.target.value;
    setPersonName(selectedStaffId);
  };
  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getStaff = async () => {
    const BASE_URL =
      SERVER_URL +
      `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setStaff(result.data);
  };

  useEffect(() => {
    if (companyId) {
      getStaff();
    }
  }, [companyId]);

  useEffect(() => {
    if (selectedRowsData) {
      setCompanyId(selectedRowsData.company_id);
      setPersonName(selectedRowsData.staff_id);
    }
  }, [selectedRowsData]);
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateSalaryModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Staff Salary Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Update Staff Salary Details</h4> */}
                    <form className="form-sample" onSubmit={updateData}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Product">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="date"
                              id="Product"
                              placeholder="Date"
                              value={selectedRowsData.date}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="company_id">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={companyId}
                              required
                              id="company_id"
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company.length > 0 &&
                                company.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Person">Employee Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleOfficeUtils}
                              value={personName}
                              required
                              id="Person"
                            >
                              <option value="">Select Person</option>
                              {staff &&
                                staff.length > 0 &&
                                staff.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >{`${item.staff_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="date">Attendance</label>
                            <input
                              type="number"
                              className="form-control"
                              name="attendance"
                              id="date"
                              placeholder="Attendance"
                              value={selectedRowsData.attendance}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                              min="1"
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="basic">Basic%</label>
                            <input
                              readOnly
                              type="number"
                              className="form-control"
                              name="basic"
                              id="basic"
                              placeholder="Basic%"
                              onChange={updateHandleChange}
                              value={selectedRowsData.basic}
                              required
                              autoComplete="off"
                              min="1"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="da">DA%</label>
                            <input
                              readOnly
                              type="number"
                              className="form-control"
                              name="da"
                              id="da"
                              placeholder="DA%"
                              onChange={updateHandleChange}
                              value={selectedRowsData.da}
                              required
                              autoComplete="off"
                              min="1"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="salary">Salary</label>
                            <input
                              type="number"
                              className="form-control"
                              name="salary"
                              id="salary"
                              placeholder="Salary"
                              value={selectedRowsData.salary}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                              min="1"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="net">Net Salary</label>
                            <input
                              type="number"
                              className="form-control"
                              name="net_salary"
                              id="net"
                              placeholder="Net Salary"
                              value={selectedRowsData.net_salary}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                              min="1"
                            />
                          </div>
                        </div> */}
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="advance">Advance</label>
                            <input
                              type="number"
                              className="form-control"
                              name="advance"
                              id="advance"
                              placeholder="Advance"
                              value={selectedRowsData.advance}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Amount">Amount</label>
                            <input
                              type="number"
                              className="form-control"
                              name="amount"
                              id="Amount"
                              placeholder="Amount"
                              value={selectedRowsData.amount}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                              min="1"
                            />
                          </div>
                        </div> */}
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={updateData}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateStaffSalary;
